import Form from "../../components/forms/Dictionary/DictionaryForm";
import DFRealtyType from "../../components/forms/Dictionary/DFRealtyType";
import DFWorkingPosition from "../../components/forms/Dictionary/DFWorkingPosition";
import DFOtherContractType from "../../components/forms/Dictionary/DFOtherContractType";
import DFAdministrativeAuthority from "../../components/forms/Dictionary/DFAdministrativeAuthority";
import { createNewForm, createEditForm, createGrid } from "./componentCreators";
import {
  defaultCols,
  workingPositionCols,
  realtyTypeCols,
  otherContractCols,
  administrativeAuthoritiesCols
} from "./columns";

// all dictionaries

const create = (name, h1, url, form = Form, columns = defaultCols) => {
  const ConnectedGrid = createGrid(name, h1, url, columns);
  const ConnectedNewForm = createNewForm(name, h1, url, form);
  const ConnectedEditForm = createEditForm(name, h1, url, form);

  return {
    name,
    h1,
    url,
    grid: ConnectedGrid,
    newForm: ConnectedNewForm,
    editForm: ConnectedEditForm,
  };
};

export const dictionariesList = [
  create("cenny-papiry", "Druh cenných papírů", "/api/ciselniky/cenny-papiry"),
  create(
    "nemovite-veci",
    "Druh nemovité věci",
    "/api/ciselniky/nemovite-veci",
    DFRealtyType,
    realtyTypeCols,
  ),
  create("druhy-organizace", "Druh orgánu", "/api/ciselniky/druhy-organizace"),
  create(
    "funkce",
    "Funkce",
    "/api/ciselniky/funkce",
    DFWorkingPosition,
    workingPositionCols,
  ),
  create("organizace", "Organizace", "/api/ciselniky/organizace"),
  create(
    "typ-cinnosti",
    "Druh činnosti",
    "/api/ciselniky/typ-cinnosti",
    DFOtherContractType,
    otherContractCols,
  ),
  create("typ-media", "Předmět media", "/api/ciselniky/typ-media"),
  create("typ-prijmu", "Druh příjmu", "/api/ciselniky/typ-prijmu"),
  create(
    "vykony-podnikani",
    "Způsob podnikání",
    "/api/ciselniky/vykony-podnikani",
  ),
  create(
    "senator-vykon-podnikani",
    "Způsob podnikání - senátor",
    "/api/ciselniky/vykony-podnikani-poslanci",
  ),
  create(
    "nabyti-movite-veci",
    "Způsob nabytí movité věci",
    "/api/ciselniky/nabyti-movite-veci",
  ),
  create(
    "nabyti-nemovite-veci",
    "Způsob nabytí nemovité věci",
    "/api/ciselniky/nabyti-nemovite-veci",
  ),
  create(
    "zpusob-pro-medium",
    "Způsob pro medium",
    "/api/ciselniky/zpusob-pro-medium",
  ),
  create(
    "zpusob-vlastnictvi",
    "Způsob vlastnictví",
    "/api/ciselniky/zpusob-vlastnictvi",
  ),
  create(
    "vyzva-funkcionari",
    "Výzva veřejnému funkcionáři",
    "/api/ciselniky/vyzva-funkcionari"
  ),
  //create('duvod-kontroly', 'Důvod kontroly', '/api/ciselniky/duvod-kontroly'),
  //create('k-postoupeni', 'K postoupení', '/api/ciselniky/k-podstoupeni'),
  //create('druh-movite-veci', 'Druh movité věci', '/api/ciselniky/druh-movite-veci'),
  //create('esm-funkce', 'Funkce pro export do systému ESM', '/api/ciselniky/esm-funkce'),
  create('duvod-kontroly', 'Důvod kontroly', '/api/ciselniky/duvod-kontroly'),
  create('k-postoupeni', 'K postoupení', '/api/ciselniky/k-podstoupeni'),
  create('vyzva-funkcionari', 'Výzva veřejnému funkcionáři', '/api/ciselniky/vyzva-funkcionari'),
  create('druh-movite-veci', 'Druh movité věci', '/api/ciselniky/druh-movite-veci'),
  create('esm-funkce', 'Funkce pro export do systému ESM', '/api/ciselniky/esm-funkce'),
  create(
      'spravni-organ',
      'Správní orgány',
      '/api/ciselniky/spravni-organ',
      DFAdministrativeAuthority,
      administrativeAuthoritiesCols
  ),
];

export const adminDictionariesList = [
  create('vyrizuje', 'Pracovník odboru střetu zájmů', '/api/ciselniky/vyrizuje'),
]

// BE entity SimpleName per dictionary segment. Source of truth for any
// code that needs to map a domain class (e.g. an audit-history owner type)
// back to its FE route segment under /ciselniky/. Used by
// components/audit/ownerRoutes.js.
const ENTITY_NAME_BY_SEGMENT = {
  "cenny-papiry": "CommercialPaperType",
  "nemovite-veci": "RealtyType",
  "druhy-organizace": "OrganizationType",
  "funkce": "WorkingPosition",
  "organizace": "Organization",
  "typ-cinnosti": "OtherContractType",
  "typ-media": "MediumType",
  "typ-prijmu": "IncomeType",
  "vykony-podnikani": "BusinessMethod",
  "senator-vykon-podnikani": "BusinessMethodDeputyOrSenator",
  "nabyti-movite-veci": "ChattelAcquisition",
  "nabyti-nemovite-veci": "RealtyAcquisition",
  "zpusob-pro-medium": "MediumMethod",
  "zpusob-vlastnictvi": "OwnershipType",
  "vyzva-funkcionari": "FunctionaryNotice",
  "duvod-kontroly": "InspectionReason",
  "k-postoupeni": "ForwardingReason",
  "druh-movite-veci": "ChattelType",
  "esm-funkce": "EsmFunction",
  "vyrizuje": "Assignee",
  "spravni-organ": "AdministrativeAuthority",
};

[...dictionariesList, ...adminDictionariesList].forEach((d) => {
  d.entityName = ENTITY_NAME_BY_SEGMENT[d.name];
});